import { unref, watchEffect } from 'vue'

import type { ReadonlyRefOrRaw } from '../types/RefOrRaw'

export const useHTMLMediaElementEventListener = <K extends keyof HTMLMediaElementEventMap>(
  elRefOrRaw: ReadonlyRefOrRaw<HTMLMediaElement | undefined>,
  eventName: K,
  listener: (event: HTMLMediaElementEventMap[K]) => void,
): void => {
  watchEffect((onCleanup) => {
    unref(elRefOrRaw)?.addEventListener(eventName, listener)
    onCleanup(() => {
      unref(elRefOrRaw)?.removeEventListener(eventName, listener)
    })
  })
}
